import styled from "styled-components";

const Page = styled.div`
  width: 100%;
`;

export default Page;
